
import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { useSelector } from "react-redux";
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import RollbarErrorTracking from "../../../utils/RollbarErrorTracking";

const TwtLanguages = (props: any) => { 

  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiOutlinedInput-root": {
        borderRadius: '0',
        textAlign: 'left'
      }
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 250,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    tab: {
      "& .MuiOutlinedInput-input": {
        padding: "15px 16px",
      },
    }
  }));

  const classes = useStyles();
  const [languagesList, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState(1);
  const allInfo = useSelector((state: any) => state);

  useEffect(() => {
    if (!!!allInfo.getTWTSessions.isLoading && !!!allInfo.getTWTSessions.isFailed && !!allInfo.getTWTSessions.data && allInfo.getTWTToken.data) {
      getTWTLanguages();
    }
  }, [allInfo.getTWTSessions, allInfo.getTWTToken]);

  const getTWTLanguages = async () => {
    const request = {
      headers: {
        "content-type": "application/json",
        "Authorization": `Bearer ${allInfo.getTWTToken.data.token}`
      }
    }
    await Axios.get(`${process.env.REACT_APP_TWT_QAROOMS}/rest/v1/languages`, request).then((response) => {
      setLanguages(response.data);
    }).catch((err: any) => {
      RollbarErrorTracking.logErrorInRollbar(err.message, "error");
    });
  }

  const handleLanguageChange = (e: any) => {
    props.selectedLanguage(e);
    setSelectedLanguage(e.target.value)
  }

  return (
    <>
      <FormControl variant="outlined" className={`${classes.formControl} ${classes.root}`}>
        <InputLabel id="demo-simple-select-outlined-label-continent">{'Select language'}</InputLabel>
        <Select
            labelId="demo-simple-select-outlined-label-continent"
            id="Continent"
            value={selectedLanguage}
            onChange={handleLanguageChange}
            label={"Select language"}        
            className={classes.tab}>
          {(languagesList.length > 0) && 
            languagesList.map((option: any, index: number) => {
              return (<MenuItem value={option.id}>{option.language}</MenuItem>);
            })          
          }
        </Select>
      </FormControl>
    </>
  )
}

export default TwtLanguages;